import React from 'react';

export function WidgetEmptyStateContent() {
  return (
    <div className='flex-fill d-flex align-items-center justify-content-center fw-bold'>
      No data available yet
    </div>
  );
}
